import React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
// import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
// const steps = [{}, {}, {}];

function Event1() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [showLoader, setShowLoader] = React.useState(false);
  const [eventsList, setEventsList] = React.useState([]);
  // const maxSteps = steps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const splitfunct = (name) => {
    let fullname = name;
    fullname = fullname.split(" ");
    return fullname[0] + " " + fullname[1];
  };

  const dateConvert = (dt) => {
    let dtval = dt;
    dtval = dtval.split("T");
    let newdt = dtval[0].split("-");
    return newdt[2];
  };

  const monthConvert = (dtv) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let dtval = dtv;
    dtval = dtval.split("T");
    let newdt = dtval[0].split("-");
    let monthval = newdt[1];
    return months[monthval - 1];
  };

  const timeConvert = (dt, edt) => {

    let startTimeval = moment
      (dt).utc()
      .format("DD-MM-YYYY hh:mm A");
    let endTimeval = moment
      (edt).utc()
      .format("DD-MM-YYYY hh:mm A");
    let sTime = startTimeval.split(" ");
    let eTime = endTimeval.split(" ");
    let sval = sTime[1] + ' ' + sTime[2] + '-' + eTime[1] + ' ' + eTime[2]
    console.log('111', sval)
    return sval;
  };

  function getStepContent(step) {
    return (
      <>
        <div className="leftEventDiv">
          <div className="eventCont1">
            <div className="eventDate">
              {dateConvert(step.start_date_time)}
              <span>{monthConvert(step.start_date_time)}</span>
            </div>
            <div className="eventRightCont">
              <h4>{step.event_title}</h4>
              <p style={{ margin: "7px 0" }}>
                Venue <b>- {step.event_venue}</b>
              </p>
              <p>
                Time{" "}
                <b>
                  -{" "}
                  {timeConvert(step.start_date_time, step.end_date_time)}
                </b>
              </p>
            </div>
          </div>
          <div className="createdBy">
            <p>
              Created by <b>{splitfunct(step.name)}</b>
            </p>
            <p>{moment(step.created_at).format("DD-MM-YYYY hh:mm A")}</p>
          </div>
        </div>
      </>
    );
  }

  async function getAllEvents() {
    setShowLoader(true);

    let bodyFormData = {
      searchq: "",
      sort: "newtoold",
      pageNo: 1,
      count: 5,
      status: "",
    };
    await makePostRequest("events/eventsListing", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          if (response.data.data.data.length > 0) {
            setEventsList(response.data.data.data);
          } else {
            setEventsList([]);
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        console.log(err)
        let errMsg = err.response.data.message;
        swal(" " + errMsg, "", "warning", { timer: 2000, buttons: false });

      });
  }
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  React.useEffect(() => {
    getAllEvents();
  }, []);
  return (
    <>
      <div>
        <Box sx={{ maxWidth: 400, flexGrow: 1 }}>

          {eventsList.length > 0 && (
            <>
              <AutoPlaySwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
              >
                {eventsList.map((step, index) => (
                  <div key={index}>
                    <form>{getStepContent(step, activeStep)}</form>
                  </div>
                ))}
              </AutoPlaySwipeableViews>


              <MobileStepper
                variant="dots"
                steps={eventsList.length}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep >= eventsList.length - 1}
                    className="slidRight"
                  >
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowLeft />
                    ) : (
                      <KeyboardArrowRight />
                    )}
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={handleBack}
                    disabled={activeStep <= 0}
                    className="slidLeft"
                  >
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowRight />
                    ) : (
                      <KeyboardArrowLeft />
                    )}
                  </Button>
                }
              />
            </>
          )}

          {/* no events */}
          {eventsList.length === 0 && (
            <Typography variant="body1" sx={{ textAlign: 'center', p: 2 }}>
              No events available
            </Typography>
          )}
        </Box>
      </div>

      {showLoader && (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      )}
    </>
  );
}

export default Event1;
